import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { BookOpenText, ArrowRight, ClipboardCheck } from "lucide-react";

const ago = (iso) => {
  const m = Math.round((Date.now() - new Date(iso).getTime()) / 60000);
  if (m < 1) return "just now";
  if (m < 60) return `${m} min ago`;
  const h = Math.round(m / 60);
  return h < 24 ? `${h} h ago` : `${Math.round(h / 24)} d ago`;
};

export const ContinueReading = () => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/textbooks/recent").then((r) => setItems(r.data)).catch(() => {});
  }, []);
  if (items.length === 0) return null;

  return (
    <div className="qs-card p-6" data-testid="continue-reading-card">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h3 className="font-display text-lg font-bold text-slate-900">Continue reading</h3>
          <p className="text-sm text-slate-500">Pick up where you left off.</p>
        </div>
        <Link to="/dashboard/library" className="text-sm font-semibold text-indigo-600 hover:underline" data-testid="continue-reading-library-link">Library</Link>
      </div>
      <div className="grid gap-3 md:grid-cols-3">
        {items.map((b) => (
          <div key={b.id} className="rounded-xl border border-slate-100 p-4 flex flex-col gap-3" data-testid={`continue-reading-item-${b.id}`}>
            <div className="flex items-start gap-3">
              <div className="w-9 h-11 rounded-md bg-indigo-600 text-white grid place-items-center text-sm font-bold shrink-0">
                {b.chapter_number ?? <BookOpenText className="w-4 h-4" />}
              </div>
              <div className="min-w-0">
                <p className="font-semibold text-sm text-slate-800 truncate">{b.chapter_title || b.title}</p>
                <p className="text-xs text-slate-500 truncate">{b.subject} · {ago(b.opened_at)}</p>
              </div>
            </div>
            <div className="flex items-center gap-2 mt-auto">
              <Link to={`/dashboard/library?open=${b.id}`} className="btn-primary text-xs" data-testid={`continue-reading-resume-${b.id}`}>
                Resume <ArrowRight className="w-3.5 h-3.5" />
              </Link>
              {b.quizzes?.length > 0 && (
                <Link to={`/exam/${b.quizzes[0].id}`} className="btn-ghost text-xs" data-testid={`continue-reading-quiz-${b.id}`}>
                  <ClipboardCheck className="w-3.5 h-3.5" /> Quiz
                </Link>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
